import { Observable } from "rxjs";

export abstract class EnviromentContextService {

    public abstract enviroment: Observable<string | null>;
    public abstract company: Observable<string | null>;
    public abstract packingStation: Observable<string | null>;
    public abstract requestWeight: Observable<boolean>;
    public abstract video: Observable<boolean>;
    public abstract videoLength: Observable<number>;
    public abstract diffVersion: Observable<boolean>;
    public abstract integrated: Observable<boolean>;

    public abstract getCompany(): string | null;
    public abstract getEnviroment(): string | null;
    public abstract getVideo(): boolean;
    public abstract getVideoLength(): number;
    public abstract getDiffVersion(): boolean;
    public abstract getIntegrated(): boolean;

    public abstract setEnviroment(name: string): void;

    public abstract setCompany(name: string): void;

    public abstract setPackingStation(name: string): void;
    public abstract setRequestWeight(requestWeight: boolean): void;
    public abstract getRequestWeight(): boolean;

    public abstract setVideo(video: boolean): void;

    public abstract setVideoLength(videoLength: number): void;

    public abstract setDiffVersion(version: boolean): void;

    public abstract setIntegrated(integrated: boolean): void;
}
